import { Input } from 'antd'
import { useEffect, useState } from 'react'
import './PriceInput.scss'
import { putCompensationDataApi } from 'api'

export const PriceInput = ({ value, onChange, record, encryption }) => {
    const [inputValue, setInputValue] = useState('')
    const handleChange = e => {
        let result = e.target.value
        let params = { ...record?.record, price: e.target.value }
        if (params?.children) {
            delete params?.children
        }
        putCompensationDataApi(params)
        setInputValue(result)
    }

    useEffect(() => {
        setInputValue(value)
    }, [])

    useEffect(() => {
        onChange(inputValue)
    }, [inputValue])

    return !record?.record?.children && record?.record?.fillType === 'auto' ? (
        <Input
            className='PriceInput'
            placeholder=''
            value={encryption ? inputValue : '******'}
            onChange={handleChange}
            allowClear={false}
        />
    ) : (
        <>{!record?.record?.children && inputValue}</>
    )
}
